let isPopupOpen = false
export const showPopup = (popup) => {
  if (popup && !isPopupOpen) {
    popup.classList.add('show')
    isPopupOpen = true
  }
}

export const closePopup = (popup) => {
  if (popup && isPopupOpen) {
    popup.classList.remove('show')
    isPopupOpen = false
  }
}
